<!--
 * @Description: 
 * @Author: 长老
 * @Date: 2019-07-31 09:57:55
 * @LastEditTime: 2019-09-05 15:26:22
 * @LastEditors: 长老
 -->
<template>
  <div>
    <div class="receive-number" v-if="isShowList && receiveInfo && receiveInfo.length > 0">
      <div class="receive-tip">- 已有{{getCount}}人领取 -</div>
      <div class="receive-head">
        <img v-for="(item,index) in receiveInfo" :key="index" v-if="index < 5" :src="item.consumerUrl" />
        <span v-if="receiveInfo.length > 5">...</span>
      </div>
      <span class="receive-open" @click="receiveOpen()"></span>
    </div>
    <div class="item-bottom-tip" v-if="!isShowList && receiveInfo && receiveInfo.length > 0">
      <ul class="ui-rows-m">
        <li class="ui-cols ui-cols-08 border-1px"></li>
        <li class="ui-cols ui-cols-2 item-bottom-title">已有{{getCount}}人领取</li>
        <li class="ui-cols ui-cols-08 border-1px"></li>
      </ul>
      <ul class="receive-list">
        <li class="ui-rows-m" v-for="(item,index) in receiveInfo" :key="index">
          <div class="touxiang">
            <img :src="item.consumerUrl" />
          </div>
          <div class="wxname">
            <p class="wxname-h">{{item.consumerName || nameLength}}</p>
            <p class="wxname-p">{{item.getTime | formatNew}}</p>
          </div>
          <div class="wxprice-r">
            <div class="wxprice">
              {{item.coinValue}}
              <i class="wxprice-rmb">云币</i>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import YunJi from '@/assets/js/YunJi'

export default {
  name: 'receive-number',
  data() {
    return {
      isShowList: true
    }
  },
  filters: {
    formatNew(value) {
      return YunJi.formatNew(value, 'MM月dd日 hh:mm')
    }
  },
  props: {
    receiveInfo: {
      type: Array,
      default() {
        return []
      }
    },
    getCount: {
      type: Number,
      default() {
        return 0
      }
    }
  },
  activated() {},
  methods: {
    /**
     * 点击展开领取列表
     */
    receiveOpen() {
      let cloudData = this.$parent.cloudData
      window.thinkingReport.track('others', {
        page_id: '00065',
        point_id: '21549',
        ABtestId: this.$parent.aBtestId,
        business_state: cloudData.type === 1 ? '领取成功' : cloudData.type === 2 ? '已抢完' : '已失效',
      })
      this.isShowList = false
    }
  }
}
</script>

<style>
.shareCoupon-error {
  width: 100%;
  height: 100%;
  background: #f1f5f8;
  text-align: center;
  position: fixed;
}
.shareCoupon-error .error-pic {
  margin: 3.44rem auto 0 auto;
}
.shareCoupon-error .error-pic,
.shareCoupon-error .error-pic img {
  width: 2rem;
  height: 2rem;
}
.shareCoupon-error .error-txt {
  margin: 0 auto;
  width: 3rem;
  font-size: 0.28rem;
  color: #9a9a9a;
  line-height: 0.4rem;
  font-weight: 700;
}
.shareCoupon-error .error-again {
  margin: 0.28rem auto 0 auto;
  border: 1px solid #9a9a9a;
  border-radius: 0.04rem;
  width: 1.56rem;
  height: 0.6rem;
  line-height: 0.6rem;
  text-align: center;
  font-size: 0.24rem;
  color: #666;
  font-weight: 700;
}
</style>
